/* eslint class-methods-use-this : 0 */
import { MeRepository } from 'common/repositories/index';
import Alert from 'directives/dashboard/ui-alert/-RFC.ui-alert-logic';

const _serviceDependencies = ['$rootScope', '$scope', '$state', '$window', 'Util',
    'ProfileImageRestService', 'UserRestService'];

let _user;
let _$scope;
let _UserRestService;
let _MeRepository;
let _Util;
let _file;
let _ProfileImageRestService;

/**
 * @ngdoc service
 * @name controllers.CropImage
 *
 * @description
 * Crop Image controller
 */
class CropImage {

    /**
     * @param  {any} $rootScope
     * @param  {any} $scope
     * @param  {any} $state
     * @param  {any} $window
     * @param  {any} Util
     * @param  {any} ProfileImageRestService
     * @param  {any} UserRestService
     */
    constructor(
        $rootScope, $scope, $state, $window, Util, ProfileImageRestService,
        UserRestService,
    ) {

        const { imageFileEvent } = $rootScope;

        _user = MeRepository.getMyUser();
        _$scope = $scope;
        _UserRestService = UserRestService;
        _MeRepository = MeRepository;
        _ProfileImageRestService = ProfileImageRestService;
        _Util = Util;

        this.$state = $state;

        _$scope.image = '';
        _$scope.croppedImage = '';
        _$scope.disabledButton = true;

        // $scope assigned functions
        _$scope.closeModal = this.closeModal;
        _$scope.onLoadDone = this.onLoadDone;
        _$scope.onError = this.onError;
        _$scope.uploadImage = this.uploadImage;

        // check if image file event exists
        if (imageFileEvent) {

            this.handleSelectedFile(imageFileEvent);

        } else {

            _Util.closeModal();

        }

    }

    handleSelectedFile(eventData) {

        const reader = new FileReader();
        [_file] = eventData.currentTarget.files;

        reader.onload = (event) => {

            _$scope.image = event.target.result;

        };

        reader.readAsDataURL(_file);

    }

    // when image loading process is done, activate save button
    onLoadDone() {

        _$scope.disabledButton = false;

    }

    // this is a fallback if the ui-cropper directive returns error
    onError() {

        Alert.error('cw.profile.picture.alerts.wrong_format');
        _Util.closeModal();

    }

    uploadImage() {

        const fileExtension = _file.type.split('/')[1];

        const profileImagePayload = {
            crm_id: _user.attributes.crm_id,
            ext: fileExtension,
            profile_image_medium: this.$parent.croppedImage,
        };

        _$scope.disabledButton = true;

        _ProfileImageRestService
            .create(profileImagePayload)
            .then((response) => {

                const userImagePayload = {
                    data: {
                        attributes: {
                            profile_image_medium: response.data.profile_image_medium,
                        },
                        type: 'users',
                        id: _user.id,
                    },
                };

                _UserRestService.update(_user.id, userImagePayload).then((user) => {

                    _Util.closeModal();
                    _MeRepository.update(user.data.data);
                    _Util.updateLastLoginObjectInLocalStorage(user.data.data);

                    Alert.success('cw.profile.picture.alerts.upload_success');

                }).then(null, () => {

                    _Util.closeModal();
                    Alert.error('cw.profile.picture.alerts.upload_error');

                });

            })
            .then(null, () => {

                _Util.closeModal();
                Alert.error('cw.profile.picture.alerts.upload_error');

            });

    }

    closeModal() {

        _Util.closeModal();

    }

}

_serviceDependencies.push(CropImage);

angular.module('controllers')
    .controller('CropImage', _serviceDependencies);




// WEBPACK FOOTER //
// ./scripts/controllers/modals/my-account/crop-image/crop-image.js